// extracted by mini-css-extract-plugin
export default {"modal-window__input":"AddStoryModal_modal-window__input__+YJ+i","modal-window__p":"AddStoryModal_modal-window__p__RFtm6"};